// removed by extract-text-webpack-plugin
module.exports = {"container":"styles__container___GIGT7","containerActive":"styles__containerActive___3AML8"};


//////////////////
// WEBPACK FOOTER
// ./core/src/components/NavigationItem/styles.css
// module id = 1176
// module chunks = 0